import { useContext } from "react";
import { ProductPageContext } from "./ProductPageContext";

export const useProductPageContext = () => {
  const context = useContext(ProductPageContext);

  if (!context) {
    throw new Error("useProductPageContext must be used within ProductPageProvider");
  }

  return context;
};
